import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=18adefb4&"
import script from "./UiDropdown.vue?vue&type=script&lang=js&"
export * from "./UiDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports